/**
 * Alpine.js wrapper component for observing and controlling the playback of a video element based on its intersection with the viewport.
 * Features include:
 * - Initializing the component.
 * - Observing the intersection of the video element with the viewport.
 * - Controlling the playback of the video based on its visibility.
 * Parameter is the threshold value for triggering video playback based on intersection ratio.
 * - Returns object containing methods and properties for observing and controlling video playback.
 */

const videoObserver = (playThreshold = 0.01) => ({
  playVideo: false,
  videoElement: null,

  init() {
    this.videoElement = this.$el.querySelector('video');

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          this.playVideo = entry.isIntersecting;
          if (this.playVideo) {
            this.videoElement.play();
          } else {
            this.videoElement.pause();
          }
        });
      },
      {
        threshold: playThreshold,
      },
    );

    observer.observe(this.videoElement);
  },
});

document.addEventListener('alpine:init', () => {
  Alpine.data('videoObserver', videoObserver);
});
